import React from 'react';
import convertStyle from './convertStyle';
import PropTypes from "prop-types";

export default class Div100vh extends React.Component {

  static propTypes = {
    withResize: PropTypes.bool
  };

  static defaultProps = {
    withResize: true
  };

  state = {
    style: {}
  };

  // On mount and window resize converts rvh values to px (if there are any).
  // Also, adds `height: 100rvh` if height is not specified at all
  updateStyle = () => {
    const convertedStyle = convertStyle(this.props.style, window.innerHeight);
    this.setState({ style: convertedStyle });
  };

  componentDidMount() {
    this.updateStyle();
    if (this.props.withResize) {
      window.addEventListener('resize', this.updateStyle);
    }
  }

  componentWillUnmount() {
    if (this.props.withResize) {
      window.removeEventListener('resize', this.updateStyle);
    }
  }

  render() {
    const { withResize, ...otherProps } = this.props;
    return <div {...otherProps} style={this.state.style} />;
  }
}